import React, { useEffect, useState } from 'react';

interface SplashScreenProps {
  onFinish?: () => void;
  minDisplayTime?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ 
  onFinish, 
  minDisplayTime = 1500 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [logoLoaded, setLogoLoaded] = useState(false);

  useEffect(() => {
    // Ensure minimum display time for the splash screen
    const minTimeTimeout = setTimeout(() => {
      if (logoLoaded) {
        handleFinish();
      }
    }, minDisplayTime);

    return () => clearTimeout(minTimeTimeout);
  }, [logoLoaded, minDisplayTime]);

  // Handle logo load event
  const handleLogoLoad = () => {
    setLogoLoaded(true);
  };

  // Handle finish event
  const handleFinish = () => {
    setIsVisible(false);
    // Call onFinish callback after animation completes
    setTimeout(() => {
      if (onFinish) onFinish();
    }, 500); // match transition duration
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed inset-0 bg-white z-50 flex flex-col items-center justify-center transition-opacity duration-500 ${logoLoaded ? 'opacity-100' : 'opacity-0'}`}
      style={{
        opacity: isVisible ? 1 : 0,
      }}
    >
      <div className="w-3/5 max-w-[240px] transform transition-transform duration-700 scale-100">
        <img 
          src="/logo512.png" 
          alt="Ultra Cleaning Service" 
          className="w-full h-auto"
          onLoad={handleLogoLoad}
        />
      </div>
      
      <div className="mt-8 flex flex-col items-center">
        <div className="w-12 h-1 bg-primary rounded-full mb-3 animate-pulse"></div>
        <p className="text-gray-600 text-sm">HR Management</p>
      </div>
    </div>
  );
};

export default SplashScreen; 